const activityEventType = {
    INVALID : 0,

    NEW_SUBMISSION : 1,

    CHANGED_SUBMISSION_STATUS : 2,

    NEW_NOTE : 3,

    CHANGED_NOTE : 4,

    DELETED_NOTE : 5,

    CHANGED_OWNER : 6,

    CHANGED_REFERRAL : 7,

    CHANGED_QUOTE_STATUS : 8,

    ADD_ATTACHMENT : 9,

    CHANGED_ATTACHMENT : 10,

    DELETED_ATTACHMENT : 11,

    SUBMISSION_CHANGESET : 12,

    NEW_UPLOADED_DRAFT : 13,

    SHARED_NOTE : 14,

    HIDDEN_NOTE : 15,

    CHANGED_POLICY_STATUS : 16,

    NEW_TASK : 19,

    CHANGED_TASK : 20,

    DELETED_TASK : 21,

    CORRESPONDENCE : 22,

    REWRITTEN_SUBMISSION : 23,

    REWRITE_SUBMISSION : 24,

    SUBMIT_RENEWAL : 25,

    MARK_RENEWED : 26,

    MARK_EXPIRED : 27,

    REVERT_TO_RENEWAL_PENDING : 28,

    SUBMIT_NON_RENEWAL : 29,

    MARK_NON_RENEWED : 30,

    REVERT_TO_NON_RENEWAL_PENDING : 31,

    RETRACT_NON_RENEWAL : 32,

    UPGRADED_FORMS : 33,

    SHARED_ATTACHMENT : 34,

    HIDDEN_ATTACHMENT : 35,

    CREATE_ENDORSEMENT : 36,

    SUBMIT_ENDORSEMENT : 37,

    EDIT_ENDORSEMENT : 38,

    SUBMIT_ENDORSEMENT_FOR_ISSUANCE : 39,

    REVERT_ENDORSEMENT_TO_SUBMITTED : 40,

    MARK_ENDORSEMENT_AS_ISSUED : 41,

    REVERT_ENDORSEMENT_TO_PENDING_ISSUANCE : 42,

    DECLINE_ENDORSEMENT : 43,

    REOPEN_ENDORSEMENT : 44,

    DELETE_ENDORSEMENT : 45,

    CREATE_ENDORSEMENT_PROPOSAL : 46,

    RESUBMIT_SUBMISSION : 47,

    SHARED_TASK : 48,

    HIDDEN_TASK : 49,

    FLAG_FOR_NON_RENEWAL : 50,

    CLEAR_NON_RENEWAL_FLAG : 51,

    COPY_SUBMISSION : 52,

    CHANGED_AGENCY_BROKERAGE : 53,

    APPROVE_ENDORSEMENT : 54,

    SPLIT_SUBMISSION : 55,

    CREATE_REWRITE : 56,

    SUBMIT_REWRITE : 57,

    EDIT_REWRITE : 58,

    SUBMIT_REWRITE_FOR_ISSUANCE : 59,

    REVERT_REWRITE_TO_SUBMITTED : 60,

    MARK_REWRITE_AS_ISSUED : 61,

    REVERT_REWRITE_TO_PENDING_ISSUANCE : 62,

    REOPEN_REWRITE : 63,

    DELETE_REWRITE : 64,

    CREATE_REWRITE_PROPOSAL : 65,

    SENT_EMAIL : 66,

    UPLOADED_EMAIL : 67

};

angular.module('gw-um-j2js')
    .constant('activityEventType', activityEventType);